<template>
  <div class="home">
    <!-- Start 顶部导航 -->
    <div class="nav-view" :style='{"background": mainColor}'>
      <div class="logo-view visible-lg" @click="clickNavItem('shouye')">
        <img class="logo-img" src="../assets/logo.png" alt="logo"/>
      </div>

      <div class="nav-right">
        <div
            class="nav-item"
            v-for="(item, index) in navData"
            :key="item.id"
            @click="clickNavItem(item.id)"
        >
          {{ item.name }}
        </div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link content-pointer">
            往届赛事
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="one">久其女娲杯2022</el-dropdown-item>
            <el-dropdown-item command="two">久其女娲杯2023</el-dropdown-item>
            <el-dropdown-item command="three">久其女娲杯2024</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 这里是手机端的右侧导航链接 -->
      <div class="logo-wrap hidden-lg">
        <div class="logo-view" @click="clickNavItem('shouye')">
          <img class="logo-img" src="../assets/logo.png" alt="logo"/>
        </div>
        <div class="logo-title">
          <div>"久其女娲杯"低代码编程大赛</div>
          <div class="sub-title">LOW-CODE DEVELOPMENT COMPETITION</div>
        </div>
      </div>
      <img
          class="menu-img hidden-lg"
          src="../assets/menu-icon.png"
          alt="menu"
          @click="showMenu = !showMenu"
      />

      <div class="nav-right-m" v-show="showMenu">
        <div
            class="nav-item"
            v-for="(item, index) in navDataM"
            :key="item.id"
            @click="clickNavItem(item.id)"
        >
          {{ item.name }}
        </div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="font-size: 12px">
            往届赛事
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="one">久其女娲杯2022</el-dropdown-item>
            <el-dropdown-item command="two">久其女娲杯2023</el-dropdown-item>
            <el-dropdown-item command="three">久其女娲杯2024</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 通知 -->
    <!-- <div class="notice">
			<div class="notice-content">首届“久其女娲杯”海南省大学生低代码编程大赛圆满落幕</div>
			<div class="notice-btn" @click.stop="toNotice">查看详情</div>
		</div> -->
    <!-- banner介绍 -->
    <div class="banner-view">
      <div class="banner-pc">
        <!--    570px  960px  -->

        <el-carousel id="el-carousel" height="570px" :interval="2000">
          <el-carousel-item>
           <img
                id="banner-img"
                class="banner-img"
                src="../assets/img2025/2025banner_8.jpg"
                alt="banner"
            />
                <!-- <div class="banner-img2"></div> -->
          <!--  <div class="sign-up-btn" @click.stop="toJoin">参加培训</div>-->
          </el-carousel-item>
          <!--          <el-carousel-item>-->
          <!--            <div @click="clickNavItem('juesaifengcai')"><img class="banner-img" src="../assets/banner-2.jpg" alt="banner" /></div>-->
          <!--          </el-carousel-item>-->
        </el-carousel>
      </div>
      <img
          class="banner-img-m"
          src="../assets/img2025/2025banner.jpg"
          alt="banner"
      />
    </div>
    <!-- 大赛介绍-PC端 -->
    <div id="dasaijieshao" class="blue-view" style="padding-bottom: 0">
      <div class="title-bg" :style='{"background": mainColor}'>
        <div class="title">
          大赛介绍
          <br/>
          <span class="title-bg-title2" :style='{"color": titleMainColor}'>COMPETITION INTRODUCTION</span>
        </div>
        <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
      </div>
      <div class="description">
        <p style="text-indent: 2em;">
          全国大学生计算机应用能力与信息素养大赛是伴随着我国计算机教育的普及和信息技术的发展面向全国高等院校和高职院校本专科所有专业大学生的一项赛事，自2011年起已经连续成功举办14届，并在2023年，被列入中国高等教育学会高校竞赛排行榜观察名录。”。
        </p>
        <p style="text-indent: 2em;">
          “久其女娲杯”低代码编程赛道是此次大赛中的一个重要赛道。本赛道主要进行低代码编程竞赛，旨在数字化转型背景下，考察选手产业认知能力、信息化意识、数字化思维、项目化逻辑等综合能力及素养，掌握利用低代码解决行业实际问题的技术路径。竞赛命题涵盖业务需求分析、数据填报收集、数据模型构建、生产流程融合等环节，旨在培养选手快速应用新技术、探索新业务变革以及领域创新的能力。
        </p>
        <p class="context-indent2em context-font-weight-bolder">主办单位</p>
        <p style="text-indent: 2em;">
          <span style="margin-right: 10px"
          >全国高等院校计算机基础教育研究会</span
          >
          <span style="margin-right: 10px">全国高等学校计算机教育研究会</span>
          <span style="margin-right: 10px"
          >工业和信息化职业教育教学指导委员会计算机分委会</span
          >
          <span>《计算机教育》杂志社</span>
        </p>
        <p class="context-indent2em context-font-weight-bolder">承办单位</p>
        <p  style="text-indent: 2em;">北京久其软件股份有限公司</p>
      </div>
    </div>
    <!-- 大赛介绍-Mobile端 -->
    <div id="dasaijieshao-m" class="phone-block">
      <!-- <div class="phone-block-title">大赛介绍</div> -->
      <div class="title-bg" :style='{"background": mainColor}'>
        <div class="title">
          大赛介绍
          <br/>
          <span class="title-bg-title2" :style='{"color": titleMainColor}'>COMPETITION INTRODUCTION</span>
        </div>
        <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
      </div>
      <p class="context-indent2em">
        全国大学生计算机应用能力与信息素养大赛是伴随着我国计算机教育的普及和信息技术的发展面向全国高等院校和高职院校本专科所有专业大学生的一项赛事，自2011年起已经连续成功举办14届，并在2023年，被列入中国高等教育学会高校竞赛排行榜观察名录。”。
      </p>
      <p class="context-indent2em">
        “久其女娲杯”低代码编程赛道是此次大赛中的一个重要赛道。本赛道主要进行低代码编程竞赛，旨在数字化转型背景下，考察选手产业认知能力、信息化意识、数字化思维、项目化逻辑等综合能力及素养，掌握利用低代码解决行业实际问题的技术路径。竞赛命题涵盖业务需求分析、数据填报收集、数据模型构建、生产流程融合等环节，旨在培养选手快速应用新技术、探索新业务变革以及领域创新的能力。
      </p>
      <div class="row-left" style="text-indent: 2em;">
        <strong>主办单位：</strong>
        <p>全国高等院校计算机基础教育研究会</p>
        <p>全国高等学校计算机教育研究会</p>
        <p>工业和信息化职业教育教学指导委员会计算机分委会</p>
        <p>《计算机教育》杂志社</p>
      </div>
      <div class="row-left">
        <strong>承办单位：</strong>
        <p style="text-indent: 2em;">北京久其软件股份有限公司</p>
      </div>
    </div>
    <!-- 技术平台-PC端 -->
    <div id="jishupingtai" class="white-view">
      <div class="title-bg" :style='{"background": mainColor}'>
        <div class="title" :style='{"color": titleMainColor}'>
          技术平台
          <br/>
          <span class="title-bg-title2" :style='{"color": titleMainColor}'>TECHNOLOGY PLATFORM</span>
        </div>
        <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
      </div>
      <div class="shadow-view">
        <div class="description context-indent2em">
          久其女娲低代码平台紧密围绕客户的业务需求和业务变革，通过持续的业务沉淀、技术抽象、能力复用，积累了一系列企业级的业务和技术组件、领域模型和算法，能够通过无代码开发、流程化编排，帮助客户快速应用新技术，探索新的业务变革和领域创新，提升价值创造力，完成高质量的数字化转型和智能化升级。
        </div>
        <div class="tiyan-btn"  :style='{"color": mainColor, "border-color": mainColor}' @click.stop="toNW">了解并体验</div>
      </div>
    </div>
    <!-- 技术平台-Mobile端 -->
    <div id="jishupingtai-m" class="phone-block">
      <div class="title-bg" :style='{"background": mainColor}'>
        <div class="title">
          技术平台
          <br/>
          <span class="title-bg-title2" :style='{"color": titleMainColor}'>TECHNOLOGY PLATFORM</span>
        </div>
        <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
      </div>
      <p style="text-indent: 2em;">
        久其女娲低代码平台紧密围绕客户的业务需求和业务变革，通过持续的业务沉淀、技术抽象、能力复用，积累了一系列企业级的业务和技术组件、领域模型和算法，能够通过无代码开发、流程化编排，帮助客户快速应用新技术，探索新的业务变革和领域创新，提升价值创造力，完成高质量的数字化转型和智能化升级。
      </p>
      <div class="tiyan-btn"  :style='{"color": mainColor}' @click.stop="toNW">了解并体验</div>
    </div>
    <!-- 参赛规则、参赛对象、奖项设置-PC端-->
    <div>
      <!-- 参赛规则-PC端-->
      <div id="cansaiguize" class="grey-view">
        <div class="title-bg" :style='{"background": mainColor}'>
          <div class="title">
            参赛规则
            <br/>
            <span class="title-bg-title2" :style='{"color": titleMainColor}'>COMPETITION RULES</span>
          </div>
          <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
        </div>
        <div class="shadow-view">
          <div class="description" style="text-indent: 2em;">
            <p style="text-align: left" v-html="gz"></p>
            <li style="color: red">
              <span
                  style="
                  color: black;
                  font-family: Microsoft YaHei;
                  font-weight: bolder;
                "
              >校内个人赛</span
              >
            </li>
            <p v-html="grdesc"></p>
            <li style="color: red">
              <span
                  style="
                  color: black;
                  font-family: Microsoft YaHei;
                  font-weight: bolder;
                "
              >区域团队赛</span
              >
            </li>
            <p v-html="qydesc"></p>
            <li style="color: red">
              <span
                  style="
                  color: black;
                  font-family: Microsoft YaHei;
                  font-weight: bolder;
                "
              >全国总决赛</span
              >
            </li>
            <p v-html="qgdesc" >
            </p>
          </div>
        </div>
      </div>
      <!-- 奖项设置-PC端 -->
      <div id="jiangxiangshezhi" class="white-view">
        <div class="title-bg" :style='{"background": mainColor}'>
          <div class="title">
            奖项设置
            <br/>
            <span class="title-bg-title2" :style='{"color": titleMainColor}'>AWARD SETTINGS</span>
          </div>
          <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
        </div>
        <div class="shadow-view">
          <div class="description">
            1. 校内个人赛、区域团队赛评选一、二、三等奖并颁发证书。
            <br/>
            2. 全国总决赛的奖项设置包括参赛选手奖项、参赛院校奖项和参赛指导教师奖项。证书由大赛组委会颁发。
            <br/>
            <table class="award" cellspacing="0" cellpadding="0">
              <tr>
                <td width="25%" rowspan="3">参赛选手奖项设置</td>
                <td width="20%">一等奖</td>
                <td width="30%">参加决赛总人数15%</td>
                <td width="25%" rowspan="3">全国总决赛产生</td>
              </tr>
              <tr>
                <td>二等奖</td>
                <td>参加决赛总人数35%</td>
              </tr>
              <tr>
                <td>三等奖</td>
                <td>参加决赛总人数50%</td>
              </tr>
              <tr>
                <td rowspan="2">参赛院校奖项设置</td>
                <td>优秀组织奖</td>
                <td>参赛院校总数的10%</td>
                <td>依据校内个人赛报名人数产生</td>
              </tr>
              <tr>
                <td>院校团体奖</td>
                <td>一等奖10%，二等奖20%，三等奖30%</td>
                <td>依据总决赛小组成绩平均分产生</td>
              </tr>
              <tr>
                <td>参赛指导教师奖项设置</td>
                <td colspan="2" align="center">一等奖、二等奖、三等奖</td>
                <td>按照指导教师指导的参赛选手获奖成绩评比产生</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- 成绩公布-PC -->
      <div id="chengjipaiming" class="white-view">
        <div class="title-bg"  :style='{"background": mainColor}'>
          <div class="title" >
            成绩公示
            <br/>
            <span class="title-bg-title2" style="color: white">PUBLICATION RESULTS</span>
          </div>
          <div class="title-triangle" ></div>
        </div>

        <!--   总决赛  -->
        <div class="shadow-view">
          <div class="description">
            <table class="award award-score" cellspacing="0" cellpadding="0">
              <tr style="border-bottom: 0.6px solid #d6d6d6">
                <td colspan="3">
                  <div style="font-weight: bold; font-size: 20px">
                    2025“久其女娲杯”低代码编程大赛全国总决赛获奖名单
                  </div>
                  <div style="font-size: 14px"><a href="http://www.nvware.com.cn/pic/2025/zjscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>
<!--                  <div style="font-size: 14px"><a href="http://10.2.20.18:18888/pic/2025/zjscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>-->
                </td>
              </tr>
              <tr v-for="(it, i) in zjsScoreList" :key="i" style="border-bottom: 0.6px solid #d6d6d6">
                <td width="33%" style="border-right: 0.6px solid #d6d6d6;">{{ it.awards }}</td>
                <td width="66%" style="padding: 0">
                  <table class="award-items" style="width: 100%" cellspacing="0" cellpadding="0">
                    <tr v-for="(el, index) in it.schools" :key="index">
                      <td width="33%" style="border-right: 0.6px solid #d6d6d6">{{ el.name }}</td>
                      <td width="33%">
                        <div style="width: 80%; text-align: left; margin: auto" v-if="el.students">
                          <p>获奖选手：{{ el.students }}</p>
                          <p>指导老师：{{ el.teachers }}</p>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!--   北部赛区  -->
<!--        <div class="shadow-view">
          <div class="description">
            <table class="award award-score" cellspacing="0" cellpadding="0">
              <tr style="border-bottom: 0.6px solid #d6d6d6">
                <td colspan="3">
                  <div style="font-weight: bold; font-size: 20px">
                    2024“久其女娲杯”低代码编程大赛区域团队赛（北部赛区）获奖名单
                  </div>
                  <div style="font-size: 14px"><a href="http://www.nvware.com.cn/pic/2024/cj/qyscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>
                </td>
              </tr>
              <tr v-for="(it, i) in bjScoreList" :key="i" style="border-bottom: 0.6px solid #d6d6d6">
                <td width="33%" style="border-right: 0.6px solid #d6d6d6;">{{ it.awards }}</td>
                <td width="66%" style="padding: 0">
                  <table class="award-items" style="width: 100%" cellspacing="0" cellpadding="0">
                    <tr v-for="(el, index) in it.schools" :key="index">
                      <td width="33%" style="border-right: 0.6px solid #d6d6d6">{{ el.name }}</td>
                      <td width="33%">
                        <div style="width: 80%; text-align: left; margin: auto" v-if="el.students">
                          <p>获奖选手：{{ el.students }}</p>
                          <p>指导老师：{{ el.teachers}}</p>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>-->
        <!--    南部赛区    -->
<!--        <div class="shadow-view">
          <div class="description">
            <table class="award award-score" cellspacing="0" cellpadding="0">
              <tr style="border-bottom: 0.6px solid #d6d6d6">
                <td colspan="3">
                  <div style="font-weight: bold; font-size: 20px">
                    2024“久其女娲杯”低代码编程大赛区域团队赛（南部赛区）获奖名单
                  </div>
                  <div style="font-size: 14px"><a href="http://www.nvware.com.cn/pic/2024/cj/qyscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>
                </td>
              </tr>
              <tr v-for="(it, i) in syScoreList" :key="i" style="border-bottom: 0.6px solid #d6d6d6">
                <td width="33%" style="border-right: 0.6px solid #d6d6d6;">{{ it.awards }}</td>
                <td width="66%" style="padding: 0">
                  <table class="award-items" style="width: 100%" cellspacing="0" cellpadding="0">
                    <tr v-for="(el, index) in it.schools" :key="index">
                      <td width="33%" style="border-right: 0.6px solid #d6d6d6">{{ el.name }}</td>
                      <td width="33%">
                        <div style="width: 80%; text-align: left; margin: auto" v-if="el.students">
                          <p>获奖选手：{{ el.students }}</p>
                          <p>指导老师：{{ el.teachers}}</p>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>-->
      </div>
      <!-- 竞赛风采-PC   -->
<!--      <div id="juesaifengcai" class="blue-view blue-none fengcai-view">
        <div class="title-bg">
          <div class="title">
            竞赛风采
            <br/>
            <span class="title-bg-title2">CONTEST STYLE</span>
          </div>
          <div class="title-triangle"></div>
        </div>
        <div class="pic-arr-div">
          <h4 style="width: 100%; text-align: center">总决赛</h4>
          <div class="pic-item" style="width: 260px; height: 180px;" v-for="(url, index) in srcList32" :key="index">
            <el-image style="width: 260px; height: 180px;" :src="url" :preview-src-list="[srcList3[index]]" lazy
                      fit="contain">
              <div slot="placeholder" class="image-slot">
                <div style="width: 260px; height: 180px; background: rgba(0, 0, 0 ,.1); line-height: 180px; text-align: center">
                加载中<span class="dot">...</span>
                </div>
              </div>
            </el-image>
          </div>
        </div>
        <div class="pic-arr-div">
          <h4 style="width: 100%; text-align: center">北部赛区</h4>
          <div class="pic-item"  style="width: 260px; height: 180px;" v-for="(url, index) in srcList11" :key="index">
            <el-image style="width: 260px; height: 180px;" :src="url" :preview-src-list="[srcList1[index]]"
                      fit="contain">
              <div slot="placeholder" class="image-slot">
                <div style="width: 260px; height: 180px; background: rgba(0, 0, 0 ,.1); line-height: 180px; text-align: center">
                  加载中<span class="dot">...</span>
                </div>
              </div>
            </el-image>
          </div>
        </div>
        <div class="pic-arr-div">
          <h4 style="width: 100%; text-align: center">南部赛区</h4>
          <div class="pic-item"  style="width: 260px; height: 180px;" v-for="(url, index) in srcList2" :key="index">
            <el-image style="width: 260px; height: 180px;" :src="url" :preview-src-list="srcList2"
                      fit="contain">
              <div slot="placeholder" class="image-slot">
                <div style="width: 260px; height: 180px; background: rgba(0, 0, 0 ,.1); line-height: 180px; text-align: center">
                  加载中<span class="dot">...</span>
                </div>
              </div>
            </el-image>
          </div>
        </div>
      </div>-->
    </div>
    <!-- 参赛规则、参赛对象、奖项设置-Mobile端 -->
    <div>
      <!-- 参赛规则-Mobile端 -->
      <div id="cansaiguize-m" class="phone-block" style="background: #f7f7f7">
        <div class="title-bg" :style='{"background": mainColor}'>
          <div class="title">
            参赛规则
            <br/>
            <span class="title-bg-title2" :style='{"color": titleMainColor}'>COMPETITION RULES</span>
          </div>
          <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
        </div>
        <div class="li-styles">
          <div class="description" style="text-indent: 2em;">
            <p style="text-align: left" v-html="gz">
            </p>
            <li>
              <span>校内个人赛</span>
            </li>
            <p v-html="grdesc" style="text-indent: 2em;"></p>
            <li>
              <span>区域团队赛</span>
            </li>
            <p v-html="qydesc" style="text-indent: 2em;">
            </p>
            <li>
              <span>全国总决赛</span>
            </li>
            <p v-html="qgdesc" style="text-indent: 2em;">
            </p>
          </div>
        </div>
      </div>
      <!-- 参赛对象-Mobile端 -->
      <!-- <div id="saidaosaiti-m" class="phone-block">
        <div class="phone-block-title">参赛对象</div>
        <p class="context-indent2em">
          大赛面向全国各普通高等院校和高等职业院校在校生，包括专科、本科和研究生层次的学生，竞赛不区分组别，同场竞技。
        </p>
      </div> -->
      <!-- 奖项设置-Mobile端 -->
      <div id="saidaosaiti-m" class="phone-block">
        <div class="title-bg" :style='{"background": mainColor}'>
          <div class="title">
            奖项设置
            <br/>
            <span class="title-bg-title2" :style='{"color": titleMainColor}'>AWARD SETTINGS</span>
          </div>
          <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
        </div>
        <div style="font-size: 14px; line-height: 25px">
          <p>
            1. 校内个人赛、区域团队赛评选一、二、三等奖并颁发证书。<br/>
            2. 全国总决赛的奖项设置包括参赛选手奖项、参赛院校奖项和参赛指导教师奖项。证书由大赛组委会颁发。
          </p>
        </div>
        <table class="award-mobile" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td width="25%" rowspan="3">参赛选手奖项设置</td>
            <td width="20%">一等奖</td>
            <td width="30%">参加决赛总人数15%</td>
            <td width="25%" rowspan="3">全国总决赛产生</td>
          </tr>
          <tr>
            <td>二等奖</td>
            <td>参加决赛总人数35%</td>
          </tr>
          <tr>
            <td>三等奖</td>
            <td>参加决赛总人数50%</td>
          </tr>
          <tr>
            <td rowspan="2">参赛院校奖项设置</td>
            <td>优秀组织奖</td>
            <td>参赛院校总数的10%</td>
            <td>依据校内个人赛报名人数产生</td>
          </tr>
          <tr>
            <td>院校团体奖</td>
            <td>一等奖10%，二等奖20%，三等奖30%</td>
            <td>依据总决赛小组成绩平均分产生</td>
          </tr>
          <tr>
            <td>参赛指导教师奖项设置</td>
            <td colspan="2" align="center">一等奖、二等奖、三等奖</td>
            <td>按照指导教师指导的参赛选手获奖成绩评比产生</td>
          </tr>
        </table>
      </div>
      <!-- 成绩公示-Mobile端 -->
<!--      <div id="chengjipaiming-m" class="phone-block">
        <div class="title-bg">
          <div class="title">
            成绩公示
            <br/>
            <span class="title-bg-title2">PUBLICATION RESULTS</span>
          </div>
          <div class="title-triangle"></div>
        </div>

        <table class="award-mobile" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td colspan="3">
              <h3>2024“久其女娲杯”低代码编程大赛全国总决赛获奖名单</h3>
              <div style="text-align: center; "><a href="http://www.nvware.com.cn/pic/2024/cj/gscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>
            </td>
          </tr>
          <tr v-for="(it,i) in zjsScoreList" :key="i">
            <td width="33%">{{ it.awards }}</td>
            <td width="66%" style="padding: 0">
              <table class="award-items-mobile" style="width: 100%" cellspacing="0" cellpadding="0">
                <tr v-for="(el, index) in it.schools" :key="index">
                  <td width="33%" style="border-right: 0.6px solid #d6d6d6">{{ el.name }}</td>
                  <td width="33%">
                    <div style="width: 80%; text-align: left; margin: auto" v-if="el.students">
                      <p>获奖选手：{{ el.students }}</p>
                      <p>指导老师：{{ el.teachers}}</p>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <table class="award-mobile" border="1" cellspacing="0" cellpadding="0" style="margin: 10px 0">
          <tr>
            <td colspan="3">
              <h3>2024“久其女娲杯”低代码编程大赛区域团队赛（北部赛区）获奖名单</h3>
              <div style="text-align: center; "><a href="http://www.nvware.com.cn/pic/2024/cj/qyscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>
            </td>
          </tr>
          <tr v-for="(it,i) in bjScoreList" :key="i">
            <td width="33%">{{ it.awards }}</td>
            <td width="66%" style="padding: 0">
              <table class="award-items-mobile" style="width: 100%" cellspacing="0" cellpadding="0">
                <tr v-for="(el, index) in it.schools" :key="index">
                  <td width="33%" style="border-right: 0.6px solid #d6d6d6">{{ el.name }}</td>
                  <td width="33%">
                    <div style="width: 80%; text-align: left; margin: auto" v-if="el.students">
                      <p>获奖选手：{{ el.students }}</p>
                      <p>指导老师：{{ el.teachers}}</p>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <table class="award-mobile" border="1" cellspacing="0" cellpadding="0" >
          <tr>
            <td colspan="3">
              <h3>2024“久其女娲杯”低代码编程大赛区域团队赛（南部赛区）获奖名单</h3>
              <div style="text-align: center; "><a href="http://www.nvware.com.cn/pic/2024/cj/qyscj.pdf" target="_blank" style="color: #cc202b; text-decoration: none">{{ scoreFileDesc }}</a></div>
            </td>
          </tr>
          <tr v-for="(it,i) in syScoreList" :key="i">
            <td width="33%">{{ it.awards }}</td>
            <td width="66%" style="padding: 0">
              <table class="award-items-mobile" style="width: 100%" cellspacing="0" cellpadding="0">
                <tr v-for="(el, index) in it.schools" :key="index">
                  <td width="33%" style="border-right: 0.6px solid #d6d6d6">{{ el.name }}</td>
                  <td width="33%">
                    <div style="width: 80%; text-align: left; margin: auto" v-if="el.students">
                      <p>获奖选手：{{ el.students }}</p>
                      <p>指导老师：{{ el.teachers}}</p>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>-->
      <!--  竞赛风采-Mobile端     -->
<!--      <div id="juesaifengcai-m" class="phone-block">
        <div class="title-bg">
          <div class="title">
            竞赛风采
            <br/>
            <span class="title-bg-title2">CONTEST STYLE</span>
          </div>
          <div class="title-triangle"></div>
        </div>
        <div class="pic-arr-div-m">
          <h4 style="width: 100%; text-align: center">总决赛</h4>
          <div class="pic-item" v-for="(url, index) in srcList32" :key="index">
            <el-image style="width: 260px; height: 180px;" :src="url" :preview-src-list="[srcList3[index]]"
                      fit="contain"></el-image>
          </div>
        </div>

        <div class="pic-arr-div-m">
          <h4 style="width: 100%; text-align: center">北部赛区</h4>
          <div class="pic-item" v-for="(url, index) in srcList11" :key="index">
            <el-image style="width: 260px; height: 180px;" :src="url" :preview-src-list="[srcList1[index]]"
                      fit="contain"></el-image>
          </div>
        </div>
        <div class="pic-arr-div-m">
          <h4 style="width: 100%; text-align: center">南部赛区</h4>
          <div class="pic-item" v-for="(url, index) in srcList2" :key="index">
            <el-image style="width: 260px; height: 180px;" :src="url" :preview-src-list="srcList2"
                      fit="contain"></el-image>
          </div>
        </div>
      </div>-->
    </div>
    <!-- 奖项荣誉-PC端 -->
    <div id="jiangxiangrongyu" class="grey-view blue-none">
      <div class="title-bg" :style='{"background": mainColor}'>
        <div class="title">
          报名方式
          <br/>
          <span class="title-bg-title2" :style='{"color": titleMainColor}'>REGISTRATION METHODS</span>
        </div>
        <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
      </div>
      <div class="shadow-view">
        <div class="description" style="text-align: center">
          本次大赛校内个人赛、区域团队赛、全国总决赛均不收取费用
          <br/>
          张老师：13439344346
          <br/><br/>
          <img
              class="banner-img-m"
              src="../assets/img2024/qrcode.png"
              alt="banner"
          />
          <br/>
        </div>
      </div>
    </div>
    <!-- 奖项荣誉-Mobile端 -->
    <div id="jiangxiangrongyu-m" class="phone-block" style="width: 89.8%">
      <div class="title-bg" :style='{"background": mainColor}'>
        <div class="title">
          报名方式
          <br/>
          <span class="title-bg-title2" :style='{"color": titleMainColor}'>REGISTRATION METHODS</span>
        </div>
        <div class="title-triangle" :style='{"border-bottom": `10px solid ${mainColor}`}'></div>
      </div>

      <div class="phone-block-title" style="margin-top: 10px">
        <div style="line-height: 25px; text-align: center">
          本次大赛校内个人赛、区域团队赛、全国总决赛均不收取费用
          <br/>
          张老师：13439344346
          <br/><br/>
          <img
              class="banner-img-m"
              src="../assets/img2024/qrcode.png"
              alt="banner"
          />
          <br/>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bottom-view" :style='{"background": mainColor}'>
      <div class="company-view">
        <div class="company-item">
          <div class="company-text company-text-title">大赛邮箱</div>
          <div class="company-text company-text-bottom">
            nvware_lcdp@jiuqi.com.cn
          </div>
        </div>
        <div class="company-item">
          <div class="company-text company-text-title">赛务联系人</div>
          <div class="company-text company-text-bottom">张静 13439344346</div>
        </div>
        <div class="company-item">
          <div class="company-text company-text-title">技术联系人</div>
          <div class="company-text company-text-bottom">芦星 13552443359</div>
        </div>
        <div class="company-item">
          <div class="company-text company-text-title">大赛地址</div>
          <div class="company-text company-text-bottom">
            由各承办院校线下组织，具体竞赛地点另行通知。
          </div>
        </div>
      </div>
      <div class="copyright">
        <span>@版权所有1997-2025北京久其软件股份有限公司</span>
        <span style="padding-left: 16px; padding-right: 2px">
          <img src="http://www.nvware.com.cn/pic/ba.png" width="12" alt="">
        </span>
        <span>
          <a  style="color: #fff; text-decoration: none" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045700" rel="noreferrer" target="_blank">京公网安备11010802045700号</a>
        </span>
        <span style="padding-left: 16px;">
          <a  style="color: #fff; text-decoration: none" href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">京ICP备11025610号-29</a>
        </span>
      </div>
    </div>
    <div class="bottom-view-m">
      <div class="company-item">
        <div class="company-text company-text-title">大赛邮箱</div>
        <div class="company-text company-text-bottom">
          nvware_lcdp@jiuqi.com.cn
        </div>
      </div>
      <div class="company-item">
        <div class="company-text company-text-title">赛务联系人</div>
        <div class="company-text company-text-bottom">张静 13439344346</div>
      </div>
      <div class="company-item">
        <div class="company-text company-text-title">技术联系人</div>
        <div class="company-text company-text-bottom">芦星 13552443359</div>
      </div>
      <div class="company-item">
        <div class="company-text company-text-title">大赛地址</div>
        <div class="company-text company-text-bottom">
          由各承办院校线下组织，具体竞赛地点另行通知。
        </div>
      </div>

      <div class="company-item">
        <div class="company-text company-text-bottom">
          <span>@版权所有1997-2025北京久其软件股份有限公司</span>
          <img src="http://www.nvware.com.cn/pic/ba.png" alt="" width="12">
          <span>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045700" rel="noreferrer" target="_blank">京公网安备11010802045700号</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      bannerHeight: 570,
      screenWidth: 2400,
      mainColor: "#0190F6",
      // mainColor: "#16C48F",
      titleMainColor: "#fff",
      showMenu: false,
      scoreFileDesc: "点击链接下载获奖名单",
      zjsScoreList:[{
        awards: "一等奖",
        schools: [
          {name: "天津电子信息职业技术学院", students: "纪春婧、马赛卓、孙明蕊", teachers: "张扬、宁阳"},
          {name: "益阳职业技术学院", students: "唐晓航、杨晶晶、肖飞扬", teachers: "谢卓冉、宋召良"},
          {name: "天津电子信息职业技术学院", students: "薛天乐、马百稳、尹浩宇", teachers: "郎振红"},
          {name: "重庆电子科技职业大学", students: "冯子健、韦冰、黄俊凡", teachers: "邓裴、丁锦箫"},
          {name: "山东职业学院", students: "周洁、王子瑞、赵明悦", teachers: "王月、于静"},
        ]
      },{
        awards: "二等奖",
        schools: [
          {name: "益阳职业技术学院", students: "谢王彬、李玉琼、吴冰", teachers: "邹欣琦、姜艳"},
          {name: "湖南财经工业职业技术学院", students: "陈熙、唐明辉、伍世杰", teachers: "唐腾、罗争"},
          {name: "湖南信息职业技学院", students: "胡婷婷、俞锦鸿、奉亚芳", teachers: "刘金花、张佃君"},
          {name: "江苏食品药品职业技术学院", students: "张博研、高露睿、范翼羚", teachers: "李佳、季秀兰"},
          {name: "湖南信息职业技术学院", students: "潘虎、周胜、张瑞", teachers: "章宜玉、张佳佳"},
          {name: "湖南科技职业学院", students: "邓鑫、陈玲、谢露", teachers: "周志化、李叶"},
          {name: "邵阳工业职业技术学院", students: "刘波涵、肖磊、潘美", teachers: "孟辰、王倩"},
          {name: "湖南财经工业职业技术学院", students: "王鑫、曾垚、车曙光", teachers: "张小寒、唐腾"},
          {name: "烟台幼儿师范高等专科学校", students: "张腾飞、张兴昂、唐明轩", teachers: "王伟星、沙凯悦"},
          {name: "陕西工业职业技术大学", students: "张天乐、张学良、陈柠汐", teachers: "仝丹娜、李爱喜"},
          {name: "北京工业职业技术学院", students: "申恪、宗浩宇、刘晏兵", teachers: "张仙妮、张艳敏"},
          {name: "山东水利职业学院", students: "邵明昊、宿美婷、秦博宇", teachers: "马涵茹、马盼盼"},
          {name: "海南软件职业技术学院", students: "王子俊、武赛奇、邱万红", teachers: "吴志君，符石"},
          {name: "常州信息职业技术学院", students: "夏成飞、伍件、夏苗淼", teachers: "安星星、李娜"},
          {name: "常州信息职业技术学院", students: "何静茹、刘佳、周梦怡", teachers: "管文强、刘斌"},
        ]
      },{
        awards: "三等奖",
        schools: [
          {name: "山东胜利职业学院", students: "方国征、陶舒丹、朱奕豪", teachers: "刘志华、吴上"},
          {name: "邵阳工业职业技术学院", students: "邓勇斌、陈海铭、谢宇瑄", teachers: "陈孟祥、许敏"},
          {name: "安徽工商职业学院", students: "胡杰、罗海峰、张亮", teachers: "代秀娟、陈翠红"},
          {name: "江苏食品药品职业技术学院", students: "陈功、谷雪、曹琼", teachers: "张丹、刘玲"},
          {name: "三亚城市职业学院", students: "李硕、申一诺、赵艺泽", teachers: "米兰、王艳"},
          {name: "天津电子信息职业技术学院", students: "林振豪、黄雨、豆紫诺", teachers: "郎振红"},
          {name: "邯郸应用技术职业学院", students: "付李彬、胡文远、李丹", teachers: "申夏鑫、李群华"},
          {name: "首都经济贸易大学", students: "陈思卓、杨润露、季景栩", teachers: "李京宁、张昕"},
          {name: "三亚城市职业学院", students: "章涛、王慧莱、刘嘉欣", teachers: "赵婉彤、米兰"},
          {name: "常州工程职业技术学院", students: "孙俊威、孟凡迪、刘浩", teachers: "严正宇、冯益斌"},
          {name: "武汉软件工程职业学院", students: "付晓伟、肖文静、张钰龙", teachers: "向军毅、熊一冰"},
          {name: "许昌职业技术学院", students: "胡翔跃、郭建伟、高一博", teachers: "徐书欣、张伟刚"},
          {name: "长沙民政职业技术学院", students: "何海棚、郭凯、贺子浩", teachers: "陈为满、王涛"},
          {name: "武汉软件工程职业学院", students: "赵书月、李基炜、谢程灼", teachers: "涂浩、刘晓倩"},
          {name: "北京农业职业学院", students: "周浩宇、沈傲霜、袁欣宇哲", teachers: "李佳宾、刘茵"},
          {name: "山东海事职业学院", students: "祝传顺、邵长森、谷训航", teachers: "陈洪仕、刘文彬"},
        ]
      },{
        awards: "院校团体奖 一等奖",
        schools: [
          {name: "湖南科技职业学院", students: ""},
          {name: "益阳职业技术学院", students: ""},
          {name: "湖南财经工业职业技术学院", students: ""},
        ]
      },{
        awards: "院校团体奖 二等奖",
        schools: [
          {name: "陕西工业职业技术大学", students: ""},
          {name: "湖南信息职业技术学院", students: ""},
          {name: "邵阳工业职业技术学院", students: ""},

          {name: "重庆电子科技职业大学", students: ""},
          {name: "天津电子信息职业技术学院", students: ""},
        ]
      },{
        awards: "院校团体奖 三等奖",
        schools: [
          {name: "许昌职业技术学院", students: ""},
          {name: "烟台幼儿师范高等专科学校", students: ""},
          {name: "江苏食品药品职业技术学院", students: ""},
          {name: "武汉软件工程职业学院", students: ""},
          {name: "山东职业学院", students: ""},

          {name: "安徽工商职业学院", students: ""},
          {name: "山东海事职业学院", students: ""},
          {name: "常州工程职业技术学院", students: ""},
        ]
      },{
        awards: "优秀组织奖",
        schools: [
          {name: "山东胜利职业学院", students: ""},
          {name: "许昌职业技术学院", students: ""},
          {name: "烟台幼儿师范高等专科学校", students: ""},
        ]

      }],
      bjScoreList: [{
        awards: "一等奖",
        schools: [
          {name: "北京工业职业技术学院", students: "陈鹏、郝丽佳、赵润峰", teachers: "张仙妮、程聪"},
          {name: "天津电子信息职业技术学院", students: "边金妮、李永萍、纪春婧", teachers: "张扬、李娜"},
          {name: "北京电子科技职业学院", students: "蒋力峻、张圣提、薛远识", teachers: "郑长亮、张萍"}
        ]
      }, {
        awards: "二等奖",
        schools: [
          {name: "山东电子职业技术学院", students: "孔祥瑞、赵彦清、孙苗苗", teachers: "赵国玲、李燕"},
          {name: "河北东方学院", students: "周安琪、罗美雪、顾若珂", teachers: "陈建奎、赵子豪"},
          {name: "北京电子科技职业学院", students: "张嘉悦、江超、薛田苗", teachers: "杜辉、孔思博"},
          {name: "河北东方学院", students: "李士华、朱伟涛、卢英杰", teachers: "朱莺莺、彭晔"},
          {name: "北京工业职业技术学院", students: "王天慈、任荣雨、刘洋", teachers: "翟欢、李保建"},
          {name: "山东商务职业学院", students: "王凯、苏滔、盛长春", teachers: "刘立静、邢茹"},
        ]
      }, {
        awards: "三等奖",
        schools: [
          {name: "山东华宇工学院", students: "董浩天、陈乐乐、窦瑞征", teachers: "杨海明、刘莹"},
          {name: "北京培黎职业学院", students: "吴迪、张金路、方依", teachers: "常静"},
          {name: "北京培黎职业学院", students: "张锦冉、陈雨昕、马政", teachers: "付强"},
          {name: "天津电子信息职业技术学院", students: "陈玉玲、高云双、马赛卓", teachers: "宁阳、颜健"},
          {name: "河北东方学院", students: "苏龙龙、李通、王天鹏", teachers: "王少伟、于发"},
          {name: "河北东方学院", students: "吴佳佳、李佳欣、王文慧", teachers: "赵丽颖、忻介夫"},
          {name: "北京工业职业技术学院", students: "赵雨柔、刘子芊、王露", teachers: "鲍晓东、周琳"},
          {name: "北京电子科技职业学院", students: "白雨蔓、张瑞鑫、吕梦丽", teachers: "李景玉、张维婷"}
        ]
      }],
      syScoreList: [{
        awards: "一等奖",
        schools: [
          {name: "邵阳工业职业技术学院", students: "沈平、唐诗怡、王文胜", teachers: "夏先哲、王倩"},
          {name: "江苏食品药品职业学院", students: "赵健、陆华民、项苏萍", teachers: "季秀兰、李佳"}
        ]
      },{
        awards: "二等奖",
        schools: [
          {name: "邵阳工业职业技术学院", students: "谢宏、杨欣怡、杨京", teachers: "陈俞霖、向飞"},
          {name: "东莞城市学院", students: "彭尔帆、张晓杨、王真", teachers: "张伟明"},
          {name: "湖南信息职业技术学院", students: "张瑞、潘虎、周胜", teachers: "章宜玉、张佳佳"},
          {name: "湖南信息职业技术学院", students: "刘俊杰、胡婷婷、何玉亭", teachers: "刘金花、蔡晨"}
        ]
      },{
        awards: "三等奖",
        schools: [
          {name: "邵阳工业职业技术学院", students: "刘波涵、肖磊、熊杰", teachers: "孟辰、廖冬晴"},
          {name: "东莞城市学院", students: "黄语桐、丁雪婉、林美仪", teachers: "陈晓书、彭玲"},
          {name: "南昌工程学院", students: "张燕海、周晶晶、卢金荣", teachers: "田秀梅"},
          {name: "东莞城市学院", students: "官俊杰、华皓毅、宋心雨", teachers: "聂慧，刘天贻"},
          {name: "广西生态工程职业技术学院", students: "蒋勇涛、杨嘉欣、马晓露", teachers: "农嘉，罗潘虎"},
          {name: "东莞城市学院", students: "赵崇佳、龙学彬、陈焕翔", teachers: "王浩亮、牛熠"},
        ]
      }],
      gz: `<div>1. 大赛面向全国各普通高等院校和高等职业院校在校生，包括专科、本科和研究生层次的学生，竞赛不区分组别，同场竞技。</div>
          <div>2. 竞赛分为校内个人赛、区域团队赛、全国总决赛三个阶段</div>
          <div>3. 决赛时间: 2025年11月，具体时间另行通知。</div>
          <div>4. 竞赛形式为线下组织，具体竞赛地点另行通知。</div>`,
      grdesc: `<div>由参赛院校自行组织，全程上机操作，比赛时长2小时，参赛选手根据要求完成任务，系统自动阅卷及评分。校赛举办院校选拔出2-4支队伍参加复赛。</div>`,
      qydesc: `<div>1）区域团队赛为多区域多院校共同比赛，形式为团队赛，不计选手个人成绩，统计参赛队的总成绩并进行排序； </div>
              <div>2）竞赛由各院校通过校内个人赛筛选参赛； </div>
              <div>3）每个参赛团队由3名学生和1-2名指导老师组成，3名选手在竞赛现场按照大赛任务要求，自行分工，相互配合完成竞赛任务； </div>
              <div>4）区域团队赛以区域为单位统一命题，现场上机操作，比赛时长为4小时，参赛选手根据要求利用久其女娲低代码竞赛平台完成赛题； </div>
              <div>5）成绩由评委人工判分，评委按照评审规则，以实名制独立对竞赛项目进行评分； </div>
              <div>6）各区域团队赛按照成绩单独评选出一、二、三等奖获奖名单。一等奖，获奖人数为参加该区域区域团队赛总人数的10%；二等奖，获奖人数为参加该区域区域团队赛总人数的20%；二等奖，获奖人数为参加该区域区域团队赛总人数的30%；</div>`,
      qgdesc: `<div>1）全国总决赛为团队赛，不计选手个人成绩，统计参赛队的总成绩并进行排名；</div>
              <div>2）竞赛由各院校通过区域团队赛筛选参赛；</div>
              <div>3）每个参赛团队由3名学生和1-2名指导老师组成，3名选手在竞赛现场按照大赛任务要求，自行分工，相互配合完成竞赛任务；</div>
              <div>4）决赛全国统一命题，现场上机操作，比赛时长为6小时，参赛选手根据要求利用久其女娲低代码竞赛平台完成赛题；</div>
              <div>5）评委按照评审规则，以实名制独立对参赛项目进行评分。根据参赛项目得分的排序，分别评出一、二、三等奖项并颁发奖励；</div>`,
      navData: [
        {id: "dasaijieshao", name: "大赛介绍"},
        {id: "jishupingtai", name: "技术平台"},
        // { id: 'saishiricheng', name: '赛程介绍' },
        {id: "cansaiguize", name: "参赛规则"},
        // { id: 'saidaosaiti', name: '参赛对象' },
        {id: "jiangxiangshezhi", name: "奖项设置"},
        {id: "chengjipaiming", name: "成绩公示"},
        /*{id: "juesaifengcai", name: "竞赛风采"},*/
        {id: "jiangxiangrongyu", name: "报名方式"},
        // { id: 'juesaifengcai', name: '决赛风采' }
      ],
      navDataM: [
        {id: "dasaijieshao-m", name: "大赛介绍"},
        {id: "jishupingtai-m", name: "技术平台"},
        // { id: 'saishiricheng-m', name: '赛程介绍' },
        {id: "cansaiguize-m", name: "参赛规则"},
        {id: "saidaosaiti-m", name: "参赛对象"},
        /*{id: "jingsaixuzhi-m", name: "奖项设置"},
        {id: "chengjipaiming-m", name: "成绩公示"},*/
        {id: "juesaifengcai-m", name: "竞赛风采"},
        {id: "jiangxiangrongyu-m", name: "报名方式"},
      ],
      xiangmujianjieUrl:
          "http://www.nvware.com.cn/download/%E9%A6%96%E5%B1%8A%E2%80%9C%E4%B9%85%E5%85%B6%E5%A5%B3%E5%A8%B2%E6%9D%AF%E2%80%9D%E6%B5%B7%E5%8D%97%E7%9C%81%E5%A4%A7%E5%AD%A6%E7%94%9F%E4%BD%8E%E4%BB%A3%E7%A0%81%E7%BC%96%E7%A8%8B%E5%A4%A7%E8%B5%9B-%E9%A1%B9%E7%9B%AE%E7%AE%80%E4%BB%8B.doc",
      shuomingshuoUrl:
          "http://www.nvware.com.cn/download/%E9%A6%96%E5%B1%8A%E2%80%9C%E4%B9%85%E5%85%B6%E5%A5%B3%E5%A8%B2%E6%9D%AF%E2%80%9D%E6%B5%B7%E5%8D%97%E7%9C%81%E5%A4%A7%E5%AD%A6%E7%94%9F%E4%BD%8E%E4%BB%A3%E7%A0%81%E7%BC%96%E7%A8%8B%E5%A4%A7%E8%B5%9B-%E5%8F%82%E8%B5%9B%E8%AF%B4%E6%98%8E%E4%B9%A6.doc",
      baomingbiaoUrl:
          "http://www.nvware.com.cn/download/%E9%A6%96%E5%B1%8A%E2%80%9C%E4%B9%85%E5%85%B6%E5%A5%B3%E5%A8%B2%E6%9D%AF%E2%80%9D%E6%B5%B7%E5%8D%97%E7%9C%81%E5%A4%A7%E5%AD%A6%E7%94%9F%E4%BD%8E%E4%BB%A3%E7%A0%81%E7%BC%96%E7%A8%8B%E5%A4%A7%E8%B5%9B-%E6%8A%A5%E5%90%8D%E8%A1%A8.xls",
      srcList1: [
        "http://www.nvware.com.cn/pic/2024/bj_fs/01.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/02.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/03.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/04.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/05.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/06.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/07.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs/08.jpg"
      ],
      srcList11: [
        "http://www.nvware.com.cn/pic/2024/bj_fs2/01.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/02.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/03.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/04.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/05.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/06.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/07.jpg",
        "http://www.nvware.com.cn/pic/2024/bj_fs2/08.jpg"
      ],
      srcList2: [
        "http://www.nvware.com.cn/pic/2024/sy_fs/11.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/12.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/13.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/14.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/15.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/16.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/17.jpg",
        "http://www.nvware.com.cn/pic/2024/sy_fs/18.jpg",
      ],
      srcList3: [
        "http://www.nvware.com.cn/pic/2024/zjs/0.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/1.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/2.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/3.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/4.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/5.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/6.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/7.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/8.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/9.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/10.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/11.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/12.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/13.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/14.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/15.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/16.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/17.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/18.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/19.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/20.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/21.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/22.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/23.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/24.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/25.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/26.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs/27.jpg",
      ],
      srcList32: [
        "http://www.nvware.com.cn/pic/2024/zjs2/0.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/1.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/2.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/3.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/4.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/5.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/6.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/7.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/8.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/9.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/10.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/11.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/12.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/13.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/14.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/15.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/16.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/17.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/18.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/19.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/20.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/21.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/22.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/23.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/24.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/25.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/26.jpg",
        "http://www.nvware.com.cn/pic/2024/zjs2/27.jpg",
      ],
      srcList4: [
        "http://www.nvware.com.cn/pic/20230312/4/DSC01471_p4283_w2432.JPG",
        "http://www.nvware.com.cn/pic/20230312/4/DSC01477_p6257_w3463.JPG",
        "http://www.nvware.com.cn/pic/20230312/4/DSC01484_p9114_w6394.JPG",
        "http://www.nvware.com.cn/pic/20230312/4/DSC01491_p9350_w7755.JPG",
        "http://www.nvware.com.cn/pic/20230312/4/DSC01501_p8959_w6347.JPG",
        "http://www.nvware.com.cn/pic/20230312/4/DSC01506_p7942_w4728.JPG",
        "http://www.nvware.com.cn/pic/20230312/4/各赛道入场.JPG",
      ],
      srcList5: [
        "http://www.nvware.com.cn/pic/20230312/5/DSC01589_p1122_w5274.JPG",
        "http://www.nvware.com.cn/pic/20230312/5/DSC01590_p2282_w1861.JPG",
        "http://www.nvware.com.cn/pic/20230312/5/DSC01591_p3823_w2244.JPG",
        "http://www.nvware.com.cn/pic/20230312/5/DSC01607_p9216_w5072.JPG",
        "http://www.nvware.com.cn/pic/20230312/5/DSC01663_p5182_w4274.JPG",
        "http://www.nvware.com.cn/pic/20230312/5/WechatIMG162.jpeg",
      ],
      srcList6: [
        "http://www.nvware.com.cn/pic/20230312/6/DSC01695_p8501_w7795.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01702_p9663_w7084.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01708_p1697_w0799.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01725_p3804_w1832.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01728_p0958_w9487.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01735_p1639_w9346.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01742_p9504_w8709.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01746_p1638_w2340.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01751_p2980_w2123.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01800_p4234_w5550.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01802_p7547_w5278.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01805_p2562_w1098.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01810_p0353_w3616.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01813_p6336_w9581.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01816_p2219_w3963.JPG",
        "http://www.nvware.com.cn/pic/20230312/6/DSC01824_p6724_w2115.JPG",
      ],
      srcList7: [
        "http://www.nvware.com.cn/pic/20230312/7/签到处.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/校园空境.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/作品展示场地.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/大赛合影照片.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/工作人员合影.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/作品展示场地2.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/久其工作人员合影.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/做平展示学生互动.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/久其工作人员合影1.JPG",
        "http://www.nvware.com.cn/pic/20230312/7/陈明锐教授闭幕发言.JPG",
      ],
    };
  },
  mounted() {
    
  },
  methods: {
   
    clickNavItem(id) {
      // console.log('Clicked item ID:', id)
      if (id === "shouye") {
        document.documentElement.scrollTop = 0;
      } else if (id === "juesaifengcai") {
        document.getElementById(id).scrollIntoView({
          behavior: "instant",
          block: "start",
          inline: "start",
        });
      } else {
        /*document.getElementById(id).scrollIntoView({
          behavior: "instant",
          block: "center",
          inline: "start",
        });*/
        let ele = document.createElement("a")
        ele.href = "#" + id
        ele.click()
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo(0, scrollTop - 100); // 将滚动条设置到距离顶部500px的位置
      }
    },
    handleCommand(command) {
      // const routeData = this.$router.resolve({ path: '/firstNvwa', query: {} });
      // window.open(routeData.href, '_blank');
      let routePath;
      if (command === "one") {
        routePath = "/firstNvwa"; // 首届女娲杯对应的路由路径
      } else if (command === "two") {
        routePath = "/home2023"; // 另一个赛事对应的路由路径
      } else if(command === "three") {
        routePath = "/home2024"; // 另一个赛事对应的路由路径
      }
      const routeData = this.$router.resolve({path: routePath, query: {}});
      window.open(routeData.href, "_blank");
    },
    toJoin() {
      window.open("https://www.97estone.com/portal/home", "_blank");
    },
    toNW() {
      window.open("https://www.jiuqi.com.cn/nwztjs/37398.jhtml", "_blank");
    },
    toNotice() {
      window.open(
          "https://mp.weixin.qq.com/s/W_mn6hVb790ZJo4s7-fT0Q",
          "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>

.el-image__placeholder {
  background: #e4e4e4;
}

.pl {
  padding-left: 4px;
}
// 0.2.0新增样式
/* logo文字样式 */
.logo-view-wz1 {
  font-size: 24px;
  color: white;
  white-space: nowrap;
  font-family: "微软雅黑";
}

.logo-view-wz2 {
  font-size: 11px;
  color: white;
  opacity: 0.8;
  padding-left: 2em;
}

/* 鼠标悬浮后编辑改小手的动态延迟 */
.content-pointer {
  transition: all 0.3s linear;
}

.content-pointer:hover {
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
}

/* 大赛介绍主办单位 */
.contest-unit {
  margin: 5px 0 5px 0;
  text-indent: 2em;
}

.award-items-mobile {
  background-color: white;
  border-collapse: collapse;
}

.award-items-mobile tr {
  border-bottom: 0.6px solid #d6d6d6;
}

.award-items-mobile tr:last-child {
  border-bottom: none;
}

.award-items {
  //border: 0.6px solid #d6d6d6;
  background-color: white;
  border-collapse: collapse;
}

.award-items tr {
  border-bottom: 0.6px solid #d6d6d6;
}

.award-items tr:last-child {
  border-bottom: none;
}

.award td {
  height: 50px;
  //text-indent: 0.5em;
  text-align: center;
  border-top: none;
}

.award {
  border: 0.6px solid #d6d6d6;
  background-color: white;
  width: 1249px;
  margin-top: 30px;
  border-collapse: collapse;
}

.award > tr > td {
  height: 50px;
  padding: 5px;
  border: 0.6px solid #d6d6d6;
  //text-indent: 0.5em;
  text-align: center;
}

.award-score > tr > td:first-child {
  font-size: 24px;
}

.award-mobile {
  border: 1px solid black;
  background-color: white;
  color: #1c1d1f;
  width: 100%;
}

.award-mobile td {
  //height: 50px;
  padding: 5px;
  //text-indent: 0.5em;
}

.context-indent2em {
  text-indent: 2em;
}

.context-font-weight-bolder {
  font-weight: bolder;
}

.title-bg-title2 {
  font-size: 14px;
  font-weight: 50;
  font-family: FZLanTingHeiS-B-GB;
  color: #e7bdc0;
}

body {
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.banner-img2 {
  width: 100%;
  height: 65vh;
  background-image: url("../assets/img2025/2025banner_8.jpg");
  background-repeat: no-repeat;
  background-size: cover;

}

// @media screen and (min-width: 1920px) {
//   .banner-img2 {
//     background-image: url("../assets/img2025/2025banner_3.jpg");
//     background-size: cover;
//     background-position: center center;
//   }
// }

// 0.1.0版本样式
.home {
  width: 100vw;
  max-width: 100%;
  min-height: 100vh;
  background-color: #fff;
  padding-top: 114px;

  .nav-view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 114px;
    //background: #2b1987;
    background: radial-gradient(ellipse at left top, #cc202b, #cc202b);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 270px;
    box-sizing: border-box;
    z-index: 999;
    /* 无文字版 */
    .logo-view {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      flex: 0 0 59px;

      .logo-img {
        width: 59px;
        height: 78px;
      }
    }

    /* 有文字版 */
    //.logo-view {
    //  flex: 0 0 59px;
    //  display: flex; /* 将子元素水平排列 */
    //  align-items: center; /* 垂直居中 */
    //  position: relative;
    //  cursor: pointer;
    //  .logo-img {
    //    width: 50px;
    //    height: 60px;
    //  }
    //}
    .logo-view::before {
      content: "";
      position: absolute;
      width: 150px;
      height: 10px;
      background: linear-gradient(
              -45deg,
              transparent 10%,
              transparent,
              rgba(255, 255, 255, 0.5),
              transparent 90%
      ) no-repeat;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-animation: searchLights 2s ease-in 2s infinite;
      animation: searchLights 2s ease-in 2s infinite;
    }

    @-webkit-keyframes searchLights {
      0% {
        left: -150px;
        top: 10px;
      }
      to {
        left: 150px;
        top: 10px;
      }
    }

    .nav-right,
    .nav-right-m {
      display: flex;
      align-items: center;

      .nav-item {
        position: relative;
        width: 96px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(0, -50%);
          width: 1px;
          height: 11px;
          background-color: #fff;
        }

        &:last-child {
          &::after {
            display: none;
          }
        }

        transition: all 0.2s linear 0s;

        &:hover {
          cursor: pointer;
          font-size: 18px;
          font-weight: 500;
        }
      }

      a {
        text-decoration: none;
      }

      .el-dropdown {
        width: 120px;
        display: flex;
        justify-content: center;
        color: #fff;
      }
    }

    .nav-right-m {
      display: none;
    }
  }

  .notice {
    position: fixed;
    left: 0;
    top: 114px;
    width: 100%;
    height: 40px;
    background-color: #ffcc66;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 40px;
    z-index: 99;
    font-size: 16px;

    .notice-content {
      color: #ff3300;
    }

    .notice-btn {
      color: #2b88fb;
      margin-left: 20px;
      cursor: pointer;
    }
  }

  .banner-view {
    position: relative;

    .banner-pc {
      display: block;
    }

    .banner-img {
      display: block;
      width: 100%;
      height: 570px;
      object-fit: cover;
    }

    .banner-img-m {
      display: none;
    }

    .sign-up-btn {
      position: absolute;
      left: 270px;
      bottom: 103px;
      width: 160px;
      height: 40px;
      //background: #2b1987;
      //background: radial-gradient(ellipse at top left, #FF003A, #FFCDD9);
      background-color: orangered;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      transition: all 0.2s linear 0s;

      &:hover {
        cursor: pointer;
        transform: scale(1.2);
      }
    }

    .fengcai-btn-m,
    .sign-up-btn-m {
      display: none;
    }
  }

  .title-bg {
    width: 400px;
    height: 82px;
    //background-image: linear-gradient(to right, #2b1987, #0e1353);
    border-radius: 20px;
    background: radial-gradient(circle, #cc202b, #cc202b);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-triangle {
    width: 0;
    height: 0;
    border-left: 5px solid transparent; /* 左边透明 */
    border-right: 5px solid transparent; /* 右边透明 */
    border-bottom: 10px solid #0190F6; /* 底部为实心 */
    transform: rotate(180deg); /* 旋转180度 */
    position: absolute;
    left: 50%;
    bottom: -10px;
  }

  .title {
    font-size: 26px;
    font-family: FZLanTingHeiS-B-GB;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    line-height: 25px;
  }

  .company-view {
    width: 999px;
    height: 180px;
    background: rgba(255, 255, 255, 0.15);
    margin: 51px 0 93px 0;
    display: flex;
    align-items: center;
    padding-left: 60px;
    justify-content: space-between;

    .company-item {
      height: 120px;
      border-left: 1px solid rgba(255, 255, 255, 0.6);
      padding-left: 30px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .company-text {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      .company-text-title {
        line-height: 14px;
      }
    }
  }

  .white-view {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //background-image: linear-gradient(to bottom right, #121461, #0e1353);
    background: white;
    padding: 50px 0;

    .description {
      width: 1249px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      //font-weight: 400;
      color: #434343;
      line-height: 26px;
      //background-color: #f7f7f7;
      padding: 20px 10px;
    }

    .tiyan-btn {
      width: 209px;
      height: 54px;
      border: 1px solid #cc202b;
      border-radius: 50px;
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #cc202b;
      line-height: 54px;
      text-align: center;
      transition: all 0.2s linear 0s;
      margin: 55px auto 0 auto;

      &:hover {
        cursor: pointer;
        transform: scale(1.2);
      }
    }

    .time-line {
      width: 840px;
      height: 200px;
      margin-top: 77px;
    }

    .jiang-desc {
      margin-top: 36px;
      width: 899px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
    }

    .pic-title {
      font-size: 20px;
      color: #000;
      padding: 30px 0 10px;
    }

    .pic-arr-div {
      width: 1200px;
      height: 220px;
      display: flex;
      align-items: center;
      overflow-x: auto;

      &::-webkit-scrollbar {
        width: 0 !important;
      }

      .pic-item {

        margin: 20px;
        transition: all 0.2s linear 0s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .blue-view,
  .grey-view {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //background-image: linear-gradient(to bottom right, #121461, #0e1353);
    background-image: url("../assets/img2024/graybg2x.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding: 50px 0;

    .description {
      width: 1249px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      //font-weight: 400;
      color: #434343;
      line-height: 26px;
      //background-color: #f7f7f7;
      padding: 20px 10px;
    }

    .tiyan-btn {
      width: 209px;
      height: 54px;
      border: 1px solid #cc202b;
      border-radius: 50px;
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #cc202b;
      line-height: 54px;
      text-align: center;
      transition: all 0.2s linear 0s;
      margin-top: 55px;

      &:hover {
        cursor: pointer;
        transform: scale(1.2);
      }
    }

    .time-line {
      width: 840px;
      height: 200px;
      margin-top: 77px;
    }

    .jiang-desc {
      margin-top: 36px;
      width: 899px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
    }

    .pic-title {
      font-size: 20px;
      color: #000;
      padding: 30px 0 10px;
    }

    .pic-arr-div-m {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      overflow-x: auto;
      margin-top: 20px;

      &::-webkit-scrollbar {
        width: 0 !important;
      }

      .pic-item {
        margin-right: 20px;
        transition: all 0.2s linear 0s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .pic-arr-div {
      width: 1200px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow-x: auto;
      margin-top: 20px;

      &::-webkit-scrollbar {
        width: 0 !important;
      }

      .pic-item {
        margin-right: 20px;
        transition: all 0.2s linear 0s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .grey-view {
    background-color: #f7f7f7;
    background-image: url("../assets/img2024/graybg2x.png");

    .shadow-view {
      position: relative;
      width: 100%;
      //background: #ffffff;
      //box-shadow: 0px 0px 11px 2px rgba(1, 93, 200, 0.15);
      //border-radius: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      //margin-top: 56px;
      //padding: 50px;
      box-sizing: border-box;

      .description {
        width: 1249px;
        color: #434343;

        .download-btn {
          color: #ff9000;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  .white-view {
    background-color: white;
  }

  .topMargin {
    margin-top: 20px;
  }

  .fengcai-view {
    padding-top: 150px;
  }

  .bottom-view {
    width: 100%;
    height: 172px;
    background-color: #cc202b;
    //background: linear-gradient(45deg, #2D2736, #24202a);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .company-view {
      background: rgba(255, 255, 255, 0);
      margin: 0;

      .company-item {
        height: 40px;
        //border-left: 1px solid rgba(255, 255, 255, 0.4);
        border-left: 1px solid white;
        color: white;

        .company-text-bottom {
          font-size: 14px;
          opacity: 0.8;
        }

        .company-text-title {
          margin-bottom: 6px;
          line-height: 12px;
          color: white;
        }
      }
    }

    .copyright {
      font-size: 11px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: white;
      line-height: 50px;
    }
  }

  .bottom-view-m {
    display: none;
  }

  .phone-img {
    display: none;
  }

  .phone-block,
  .hidden-lg {
    display: none;
  }
}

@media screen and (max-width: 900px) {
  .home {
    .white-view,
    .shadow-view,
    .visible-lg {
      display: none;
    }

    .hidden-lg {
      display: block;
    }

    .logo-wrap {
      display: flex;

      color: #fff;
      gap: 5px;

      .logo-title {
        font-size: 14px;
        white-space: nowrap;

        .sub-title {
          font-size: 8px;
          margin-top: 2px;
        }
      }
    }

    padding-top: 40px;

    .nav-view {
      max-width: 100%;
      box-sizing: border-box;
      height: 60px;
      padding: 0 20px 0 16px;
      align-items: center;

      .logo-view {
        flex: 0 0 36px;

        .logo-img {
          width: 30px;
          height: auto;
        }
      }

      .nav-right {
        display: none;
      }

      .menu-img {
        // width: 30px;
      }

      .nav-right-m {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        background: #00000060;
        transform: translateY(100%);
        padding-bottom: 10px;

        .nav-item {
          height: 30px;
          line-height: 30px;
          font-size: 12px;

          &::after {
            display: none;
          }

          &:hover {
            cursor: pointer;
            font-size: 10px;
            font-weight: 400;
          }
        }

        .el-dropdown {
          //   width: 55px;
        }
      }
    }

    .context-indent2em {
      text-indent: 2em;
    }

    .notice {
      position: fixed;
      left: 0;
      top: 69px;
      width: 100%;
      height: 40px;
      background-color: #ffcc66;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 20px;
      z-index: 99;
      font-size: 12px;

      .notice-content {
        color: #ff3300;
      }

      .notice-btn {
        color: #2b88fb;
        margin-left: 8px;
        cursor: pointer;
      }
    }

    .banner-view {
      position: relative;

      .banner-pc {
        display: none;
      }

      .banner-img {
        display: none;
      }

      .banner-img-m {
        display: block;
        width: 100%;
        height: auto;
      }

      .sign-up-btn {
        display: none;
      }

      .fengcai-btn-m,
      .sign-up-btn-m {
        display: block;
        position: absolute;
        left: 50%;
        bottom: 35px;
        transform: translate(-50%, 0);
        width: 112px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background: #6998f9;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
      }

      .fengcai-btn-m {
        bottom: 260px;
        background: #5c70f0;
      }
    }

    .grey-view,
    .blue-view {
      display: none;
    }


    .blue-none {
      display: none;
    }

    .fengcai-view {
      display: flex;
      padding-top: 100px;

      .pic-arr-div {
        width: 100%;
        display: none;
      }
    }

    .bottom-view {
      display: none;
    }

    .phone-img {
      width: 100%;
      height: auto;
      display: block;
      margin-top: -1px;
    }

    .title-bg {
      display: none;
    }

    .phone-block {
      width: fit-content;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 20px;
      text-align: justify;
      line-height: 26px;
      font-size: 16px;
      margin: auto;

      color: #474747;

      .row-left {
        text-align: left;
        text-indent: 0;
        align-self: flex-start;
        line-height: 1;
        margin-top: 20px;
      }

      .title-bg {
        width: 250px;
        max-width: 60%;
        height: auto;
        padding: 8px 0;
        border-radius: 5px;
        background: radial-gradient(circle, #cc202b, #cc202b);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-bottom: 10px;
      }

      .title-triangle {
        width: 0;
        height: 0;
        border-left: 3px solid transparent; /* 左边透明 */
        border-right: 3px solid transparent; /* 右边透明 */
        border-bottom: 5px solid #cc202b; /* 底部为实心 */
        transform: rotate(180deg); /* 旋转180度 */
        position: absolute;
        left: 50%;
        bottom: -5px;
      }

      .title {
        font-size: 18px;
        font-family: FZLanTingHeiS-B-GB;
        color: #ffffff;
        // font-weight: normal;
        text-align: center;
        line-height: 1;
      }

      .title-bg-title2 {
        font-size: 12px;
        font-weight: 50;
        font-family: FZLanTingHeiS-B-GB;
        color: #e7c2c5;
        line-height: 1;
      }

      .tiyan-btn {
        width: fit-content;
        padding: 5px 35px;
        height: unset !important;
        border: 1px solid #cc202b;
        border-radius: 50px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: normal;
        color: #cc202b;
        text-align: center;
        transition: all 0.2s linear 0s;
        margin: 30px auto 0 auto;

        &:hover {
          cursor: pointer;
          transform: scale(1.2);
        }
      }

      .li-styles li {
        color: #c9222b;
        line-height: 1;
        margin-top: 35px;

        span {
          color: #434343;
          font-family: Microsoft YaHei;
          font-weight: bolder;
          margin-left: -5px;
        }
      }

      .award-mobile {
        border: none;
        border-bottom: 1px solid #00000060;
      }

      //   .phone-tiyan-btn {
      //     background: #ffbb00;
      //     width: 100px;
      //     border-radius: 6px;
      //     text-align: center;
      //     line-height: 40px;
      //     font-size: 16px;
      //     font-weight: bold;
      //     margin-top: 20px;
      //   }
    }

    .bottom-view-m {
      width: 100%;
      height: auto;
      background-color: #cc202b;
      display: block;
      padding: 40px 20px 30px;
      text-align: left;

      .company-item {
        height: 40px;
        color: white;
        margin-bottom: 20px;

        .company-text-bottom {
          font-size: 14px;
          opacity: 0.8;

          a {
            text-decoration: none;
          }
        }

        .company-text-title {
          margin-bottom: 6px;
          line-height: 12px;
          color: white;
        }
      }
    }
  }
}
</style>
